module.exports = __webpack_public_path__ + "img/icon_intellig_loc_ancient_select.bb1a5c48.svg";